// src/pages/resources/ResourcesPage.tsx
import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '@/contexts/AuthContext';
import { useBranding } from '@/contexts/BrandingContext';
import HelpCenterTab from './resources/HelpCenterTab';
import RoadmapTab from './resources/RoadmapTab';

export default function ResourcesPage() {
  const { profile } = useAuth();
  const { isWhiteLabel, branding } = useBranding();
  const isPartnerClient = profile?.user_type === 'partner_client';
  const shouldHideRoadmap = isPartnerClient && isWhiteLabel;
  const showPartnerHelp = isWhiteLabel && !!branding.helpCenterContent && isPartnerClient;
  const [active, setActive] = useState('help');

  // For partner clients with partner help center, show only the help center without tabs
  if (showPartnerHelp) {
    return <HelpCenterTab />;
  }

  // The handleContactUsClick function has been removed from here.
  // Its functionality is now part of the FloatingActionButton component.

  return (
    // The outer padding div is removed as DashboardLayout's <main> element will handle padding.
    <div>
      <h1 className="text-2xl font-bold mb-6">Resources</h1>
      <Tabs value={active} onValueChange={setActive} className="w-full">
        <TabsList className={`grid w-full mb-6 max-w-md ${shouldHideRoadmap ? 'grid-cols-1' : 'grid-cols-2'}`}>
          <TabsTrigger value="help">Help Center</TabsTrigger>
          {!shouldHideRoadmap && <TabsTrigger value="roadmap">Roadmap</TabsTrigger>}
          {/* The "Contact Us" TabsTrigger has been removed. */}
        </TabsList>
        <TabsContent value="help">
          <HelpCenterTab />
        </TabsContent>
        {!shouldHideRoadmap && (
          <TabsContent value="roadmap">
            <RoadmapTab />
          </TabsContent>
        )}
        {/* No <TabsContent value="contact" /> is needed. */}
      </Tabs>
    </div>
  );
}